import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { firebaseConnect, populate } from 'react-redux-firebase';
import { objToArr } from '../../helpers';

import ProjectPreview from '../../components/Project/ProjectPreview';

const ProjectPreviewContainer = props => <ProjectPreview {...props} />;

ProjectPreviewContainer.defaultProps = {};

ProjectPreviewContainer.propTypes = {};

const populates = [
  { child: 'createdBy', root: 'users', keyProp: 'key' },
  { child: 'owners', root: 'users', keyProp: 'key' },
];

const mapStateToProps = (state, props) => {
  const { firebase, router } = state;
  return {
    history: objToArr(populate(firebase, 'projectHistory', populates)).reverse(),
    selectedProject: populate(firebase, 'selectedProject', populates),
  };
};

export default compose(
  connect(({ firebase }) => ({
    auth: firebase.auth,
  })),
  firebaseConnect((props) => {
    if (props.selected && props.selected.length === 1) {
      const key = props.selected[0];
      return [
        {
          path: `/history/projects/${key || ''}`,
          storeAs: 'projectHistory',
          queryParams: ['orderByChild=createdAt'],
          populates,
        },
        {
          path: `/projects/${key || ''}`,
          storeAs: 'selectedProject',
          populates,
        },
      ];
    }
    return [];
  }),
  connect(mapStateToProps),
)(ProjectPreviewContainer);



// WEBPACK FOOTER //
// ./src/containers/Project/ProjectPreviewContainer.js